import { render, staticRenderFns } from "./source-of-income-and-expenses.vue?vue&type=template&id=138dbc8f&"
import script from "./source-of-income-and-expenses.vue?vue&type=script&lang=js&"
export * from "./source-of-income-and-expenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports